import { TEAL, CREAM30 } from "../utils/constants";

function Footer({ user }) {
  return (
    <div style={{ textAlign: "center", padding: "32px 0 16px", color: CREAM30, fontSize: 12, fontFamily: "'JetBrains Mono', monospace", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
      Powered by
      <a
        href="https://www.linkedin.com/newsletters/ai-signals-navigating-change-7344886124940607488/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "inherit", textDecoration: "underline", textUnderlineOffset: 2 }}
        onMouseEnter={(e) => { e.currentTarget.style.color = TEAL; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = "inherit"; }}
        title="AI Signals: Navigating Change — LinkedIn newsletter"
      >
        AI Signals
      </a>
      Research
      {user && (
        <>
          <span aria-hidden="true" style={{ color: CREAM30 }}>·</span>
          <a href="#account"
             style={{ color: "inherit", textDecoration: "underline", textUnderlineOffset: 2 }}
             onMouseEnter={(e) => { e.currentTarget.style.color = TEAL; }}
             onMouseLeave={(e) => { e.currentTarget.style.color = "inherit"; }}>
            Your data
          </a>
        </>
      )}
    </div>
  );
}

export default Footer;
